import { Component, OnInit } from '@angular/core';
import { TopsellerService } from '../topseller.service';
import { WishlistService } from '../wishlist.service';
import { BaseComponent } from '../classes/BaseComponent';
import { Global } from '../classes/Global';
import { Log } from '../helpers/Log';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { StorageHelper } from '../helpers/StorageHelper';
import { AiStructuredDataHelper } from '../helpers/AiStructuredDataHelper';

@Component({
  selector: 'app-prime-video-deals',
  templateUrl: './prime-video-deals.component.html',
  styleUrls: ['./prime-video-deals.component.scss'],
  providers: [ TopsellerService, WishlistService ]
})
export class PrimeVideoDealsComponent extends BaseComponent implements OnInit {

  items;
  schema;

  constructor(
    private topSellerService: TopsellerService,
    private wishListService: WishlistService
  ) {
    super();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.schema = AiStructuredDataHelper.buildDealsPageSchema(
      this.getString('primeVideoDeals'),
      "https://www.cheapcharts.com/" + Global.getCountry() + "/" + this.getString('primeVideoDealsUrl'),
      Global.getCountry(),
      Global.AMAZON,
      Global.BUYMOVIES
    );
    this.topSellerService.getTopSellersForStartPage(Global.getCountry(), 5).subscribe(res => {
      if (res && res["results"]) {
        this.items = res["results"][Global.AMAZON];
      }
    }, err => {
      Log.getInstance().d(err);
    });
  }

  getLangForHeroImage(): string {
    let lang = InternationalizationHelper.getTwoCharactersLanguage();

    if (lang != "de" && lang != "en" && lang != "fr") {
      lang = "en";
    }

    return lang;
  }

  wishListClicked(item) {
    const id = item.idInStore || item.itemID;
    this.wishListService.addItem(Global.getCountry(), Global.AMAZON, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortWishList(Global.AMAZON);
    }, err => {

    });
  }

  getShortWishList(store?: string) {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    store = store ? store : Global.getStore();
    if (sessionToken){
      this.wishListService.getShortWishlist(
        Global.getCountry(),
        store,
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
          shortWishlist[store] = res["results"];
          StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        }
      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

}
